module.exports = __webpack_public_path__ + "img/logo.48756a40.svg";